import { cn } from '@/lib/utils/cn'
import { BOARD_CELL_LEGEND, DAY_BUCKET_LEGEND, type ReservationSwatchTone } from '@/lib/venue/reservationViewModel'

/** `ReservationSwatchTone` → Tailwind 배경색. 캘린더 셀·현황판 칸도 같은 매핑을 쓴다(색상 일관성). */
export const SWATCH_CLASS: Record<ReservationSwatchTone, string> = {
  success: 'bg-success-500',
  warning: 'bg-warning-500',
  brand: 'bg-brand-500',
  neutralLight: 'bg-slateish-50 border border-slateish-300',
  neutralDark: 'bg-slateish-300',
}

/** 범례 스와치 색과 같은 축의 옅은 배경(셀 채우기용) + 글자색. */
export const SWATCH_FILL_CLASS: Record<ReservationSwatchTone, string> = {
  success: 'bg-success-100 text-success-500',
  warning: 'bg-warning-100 text-warning-500',
  brand: 'bg-brand-100 text-brand-500',
  neutralLight: 'bg-slateish-50 text-slateish-600',
  neutralDark: 'bg-slateish-300 text-ink-500',
}

function LegendDot({ tone }: { tone: ReservationSwatchTone }) {
  return <span aria-hidden="true" className={cn('h-2.5 w-2.5 shrink-0 rounded-full', SWATCH_CLASS[tone])} />
}

/**
 * 예약 범례 — 2종(설계 §2-4).
 * - `variant='DAY_BUCKET'`: 캘린더 날짜 셀 위 범례 A(예약 완료·임시 점유 중·예약 확인 중·예약 가능·휴무·차단).
 * - `variant='BOARD'`: 현황판 코트×시간 그리드 위 범례 B(앱 예약·전화·현장·레슨·차단·휴무).
 */
export function ReservationLegend({ variant }: { variant: 'DAY_BUCKET' | 'BOARD' }) {
  const entries = variant === 'DAY_BUCKET' ? DAY_BUCKET_LEGEND : BOARD_CELL_LEGEND

  return (
    <ul className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-slateish-600">
      {entries.map((entry) => (
        <li key={entry.key} className="flex items-center gap-1.5">
          <LegendDot tone={entry.tone} />
          {entry.label}
        </li>
      ))}
    </ul>
  )
}
